import { 
	triggerCalendarRefetch,
	updateNotesEditor,
	getEvents
} from '../../../state/events'
import { 
	getAllNotes,
} from '../../../state/clientNotesSlice'
import { dateToAPIStandard } from '../../../util/datetime'
import { 
	useSelector, 
	useDispatch 
} from 'react-redux'
import { 
	updateNote,
	deleteNote, 
	saveNote, 
} from '../../../state/clientNotesSlice'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import { useState } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import DatePicker from "react-datepicker"
import Modal from 'react-bootstrap/Modal'

const NotesModal = ()=>{
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const {show,id,date,note,clientId} = useSelector(
		state => state.allEvents.notesEditor
	)

	const [status,setStatus] = useState('idle')
	const [isCopying,setIsCopying] = useState(false)

	const refreshCalendar = ()=>{
		dispatch(triggerCalendarRefetch({refetch:true}))
	}

	function dispatchGetEvents() {
		dispatch(getAllNotes({client_id:clientId}))
		const eventTypes = ['workout','task','nutrition']
		return Promise.all(eventTypes.map(
			event_type => dispatch(getEvents({
				event_type,
				client_id:clientId,
				filter:'client'
			}))
		))
	}

	const setNoteDate = date => {
		dispatch(updateNotesEditor({
			date:dateToAPIStandard(date)
		}))
	}

	const handleDelete = ()=>{
		if (!window.confirm('Are you sure you want to delete this note?')) return
		setStatus('pending')
		statusDispatch(deleteNote({
			client_id: clientId,
			note_id: id,
		}), "note", "delete").then( res => {
			setStatus('idle')
			clearNotesModal()
			refreshCalendar()
			dispatchGetEvents()
		})
	}

	const handleCreate = ()=>{
		setStatus('pending')
		statusDispatch(saveNote({
			dateCreated:date,
			newNote: note,
			client_id: clientId
		}), "note", "create").then( res => {
			setStatus('idle')
			clearNotesModal()
			refreshCalendar()
			dispatchGetEvents()
		})
	}

	const handleCopy = ()=>{
		setStatus('pending')
		statusDispatch(saveNote({
			client_id: clientId,
			dateCreated:date,
			newNote: note,
		}), "note", "create").then( res => {
			setStatus('idle')
			clearNotesModal()
			refreshCalendar()
			dispatchGetEvents()
		})
	}

	const handleUpdate = ()=>{
		setStatus('pending')
		statusDispatch(updateNote({
			dateCreated: date,
			note_id: id,
			note,
		}), "note", "update").then( res => {
			setStatus('idle')
			clearNotesModal()
			refreshCalendar()
			dispatchGetEvents()
		})
	}

	const editing = Boolean(id)

	const handleChange = e => {
		dispatch(updateNotesEditor({
			note:e.target.value
		}))
	}

	const clearNotesModal = ()=>{
		setIsCopying(false)
		dispatch(updateNotesEditor({
			show:false,
			date:null,
			id:null,
			clientId:null,
			note:''
		}))
	}

	return (
		<Modal
			show={show}
			onHide={clearNotesModal}
			style={{ 
				display: 'flex !important', 
				flexDirection: 'column', 
				alignItems: 'center' 
			}}
		>
			<Modal.Header className="w-100" closeButton>
				<Modal.Title >
					<span>
						{
							editing 
							? "Edit Note" 
							: isCopying ? "Copy Note" : "Add New Note"
						}
					</span>
					<div> 
						<small style={{ fontSize: "14px" }}>
							<i className="fa fa-info-circle mr-1"></i>
							Notes are hidden from clients
						</small>
					</div>
				</Modal.Title>
			</Modal.Header>
			<hr style={{ width: '100%', margin: '0px' }} />

			<Modal.Body style={{ width: '100%' }}>
				Select Date:
				<DatePicker
					onChange={
						(date) => { setNoteDate(date) }
					}
					dateFormat="EEE, MMM d, yyyy"
					selected={
						Boolean(date)
						? new Date(date.split(' ').join('T'))
						: date
					}
					className="mb-2 ml-2"
				/>
				<textarea
					rows="5"
					className="p-1"
					style={{ 
						whiteSpace: 'pre-wrap', 
						width: '100%' 
					}}
					value={note}
					onChange={handleChange}
				/>
			</Modal.Body>
			<Modal.Footer>
				{editing && 
					<Button
						style={{ "fontSize": "14px" }}
						variant="outline-danger"
						onClick={handleDelete}
						disabled={status === 'pending'}
						className="ml-2"
						size="sm"
					>
						{
							status === 'pending' 
							? <Spinner animation="border" variant="danger-outline" size="sm" /> 
							: "Delete"
						}
					</Button>
				}
				<Button
					variant="outline-secondary"
					onClick={clearNotesModal}
					className="ml-2 mr-auto"
					size="sm"
				>
					Cancel
				</Button>
				{!isCopying && 
					<Button
						variant="outline-primary"
						onClick={()=>{
							setIsCopying(true)
						}}
						className="ml-2"
						size="sm"
					>
						Copy
					</Button>
				}
				<Button
					size="sm"
					disabled={ status === 'pending' }
					variant={
						isCopying 
						? "success" 
						: "primary"
					}
					className="ml-2"
					onClick={
						editing && !isCopying 
						? handleUpdate 
						: handleCreate
					}
				>
					{status === 'pending' 
						? <Spinner animation="border" variant="danger-outline" size="sm" /> 
						: isCopying ? "Copy Note" : "Save"
					}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default NotesModal